var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTargetYellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66669 0.666748L8.66735 2.70809C11.0795 3.00918 12.9913 4.92117 13.2921 7.33342H15.3334V8.66675L13.292 8.66742C12.991 11.0793 11.0793 12.991 8.66735 13.2921L8.66669 15.3334H7.33335V13.2921C4.92111 12.9913 3.00912 11.0795 2.70803 8.66742L0.666687 8.66675V7.33342H2.70795C3.00877 4.92094 4.92088 3.00883 7.33335 2.70801V0.666748H8.66669ZM8.00002 6.66675C7.26362 6.66675 6.66669 7.26368 6.66669 8.00008C6.66669 8.73648 7.26362 9.33342 8.00002 9.33342C8.73642 9.33342 9.33335 8.73648 9.33335 8.00008C9.33335 7.26368 8.73642 6.66675 8.00002 6.66675Z",
    fill: "#FFC90C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetYellow);
export default __webpack_public_path__ + "static/media/target-yellow.0006eac87d3126651ec1fa9024b06c8b.svg";
export { ForwardRef as ReactComponent };